import type { User } from "lucia";
import { useState } from "nuxt/app";

/**
 * Return the current user (or null if not authenticated)
 * The value of the user will be filled in by the middleware.
 */
export const useUser = () => {
  const user = useState<User | null>("user", () => null);
  return user;
};

/**
 * Return the current user (always present. Error if not authenticated)
 * The value of the user will be filled in by the middleware.
 *
 * This is useful for pages that are always protetcted (e.g. admin pages) so
 * we don't have to bother with the null case.
 */
export const useAuthenticatedUser = () => {
  const user = useUser();
  return computed(() => {
    const userValue = unref(user);
    if (!userValue) {
      throw createError("useAuthenticatedUser() can only be used in protected pages");
    }
    return userValue;
  });
};

/**
 * Logout the current user and redirect to the login page
 */
export const logout = async () => {
  await $fetch("/api/auth/logout", {
    method: "POST",
  });
  await navigateTo(Page.AUTH_LOGIN);
};

export const isUserAdmin = (user: User | null) => {
  if (user == null || !user.isAdmin || !user.isActive) {
    return false;
  }
  return true;
};
